import { createSlice } from '@reduxjs/toolkit';

const loadCartFromStorage = () => {
    try {
        const storedCart = localStorage.getItem('maya_cart');
        return storedCart ? JSON.parse(storedCart) : { items: [], totalAmount: 0 };
    } catch (error) {
        console.error("Error loading cart from storage:", error);
        return { items: [], totalAmount: 0 };
    }
};

const saveCartToStorage = (state) => {
    try {
        localStorage.setItem('maya_cart', JSON.stringify({
            items: state.items,
            totalAmount: state.totalAmount
        }));
    } catch (error) {
        console.error("Error saving cart to storage:", error);
    }
};

const initialState = loadCartFromStorage();

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addItem: (state, action) => {
            const newItem = action.payload;
            const existingItem = state.items.find(
                item => item.productId === newItem.productId && item.size === newItem.size
            );

            if (existingItem) {
                existingItem.quantity += newItem.quantity;
            } else {
                state.items.push(newItem);
            }
            state.totalAmount = state.items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
            saveCartToStorage(state);
        },
        removeItem: (state, action) => {
            const { productId, size } = action.payload;
            state.items = state.items.filter(
                item => !(item.productId === productId && item.size === size)
            );
            state.totalAmount = state.items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
            saveCartToStorage(state);
        },
        updateQuantity: (state, action) => {
            const { productId, size, quantity } = action.payload;
            const item = state.items.find(
                item => item.productId === productId && item.size === size
            );
            if (item) {
                item.quantity = quantity;
            }
            state.totalAmount = state.items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
            saveCartToStorage(state);
        },
        setCart: (state, action) => {
            state.items = action.payload.items || [];
            state.totalAmount = state.items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
            saveCartToStorage(state);
        },
        clearCart: (state) => {
            state.items = [];
            state.totalAmount = 0;
            saveCartToStorage(state);
        }
    }
});

export const { addItem, removeItem, updateQuantity, setCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
